<template>
  <el-container>
    <el-aside :width="asideWidth"
              @click.native="change2">
      <div @click="toHome">
        <div class="collapseBtn">
          <div class="header">
            <img v-if="logo"
                 :src="logo"
                 class="sidebar-logo" />
            <div class="headertext">道宏ai后台管理系统</div>
          </div>

        </div>
      </div>
      <el-menu @click="change2"
               ref="menu"
               text-color="#fffff3"
               background-color="#333744"
               unique-opened
               router
               :collapse="!isCollapse"
               :collapse-transition="false"
               :default-active="firstPath"
               class="el-collapse-menu">
        <menuTree :menuList="menuList"></menuTree>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header id="headerScoll">
        <div class="box">
          <div v-show="zvisible"
               :style="{ left: left - 190 + 'px', top: top + 'px' }"
               class="zdiv">
            <li @click="removeAll">关闭所有标签</li>
            <li @click="closeLeft">关闭左边标签</li>
            <li @click="closeRight">关闭右边标签</li>
            <li @click="closeOther">关闭其他标签</li>
          </div>
        </div>

        <div class="changeCss"
             id="toScoll"
             ref="toScoll"
             @click="change2">
          <el-tabs @contextmenu.prevent.native="openRightMenu($event)"
                   ref="tabs"
                   v-model="editableTabsValue"
                   type="border-card"
                   closable
                   @tab-remove="removeTab"
                   @tab-click="open">
            <el-tab-pane v-for="(item,index) in tags"
                         :key="item.id"
                         :label="item.showName"
                         :name="item.showName"
                         :effect="$route.path==item.linkUrl?'dark':'plain'">
            </el-tab-pane>
          </el-tabs>
        </div>

        <el-dropdown ref="drop"
                     class="rightImage"
                     @click.native="change2">
          <span class="el-dropdown-link">
            当前用户:<span style="whiteSpace: nowrap;">{{name}}</span>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item style="whiteSpace: nowrap;"
                              @click.native="changePwd()">修改密码</el-dropdown-item>
            <el-dropdown-item style="whiteSpace: nowrap;"
                              @click.native="out()">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </el-header>

      <el-main :class="$route.path=='/sys/homeone'?'havePad':''"
               @click.native="change2">

        <keep-alive :include="getTagsName"
                    :exclude="exTags"
                    :max="30">
          <router-view></router-view>
        </keep-alive>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import logoImg from '@/assets/logo.png'
import store from '@/store'
import menuTree from '@/components/MenuTree.vue'
export default {
  components: {
    menuTree: menuTree,
  },
  computed: {
    ...mapGetters({
      exTags: "getExcludeCache"
    }),
    getTagsName () {
      return this.tags.map(t => t.cssName);
    }
  },
  watch: {
    '$route.path': {
      handler: function (newValue, oldValue) {
        setTimeout(() => {
          this.tags = store.state.movemenu
          this.firstPath = newValue
          // this.$nextTick(()=>{
          // let index;
          // = this.tags.findIndex(function(value) {
          //   return value.linkUrl == newValue;
          // })
          for (let i = 0; i < this.tags.length; i++) {
            // debugger
            if (this.tags[i].linkUrl == newValue) {
              this.index = i
            }
          }
          this.editableTabsValue = this.tags[this.index]?.showName

        }, 0)

        // })

      },
      // immediate: true
    },
    editableTabsValue: {
      handler: function (val) {
        if (val == undefined) {

          // 如果是增加或者编辑则把当前路由的cssName添加到excludeCache中，不让其缓存
          this.startMenu?.cssName && store.state.excludeCache.push(this.startMenu.cssName);
        } else {
          // 否则先找到当前路由的cssName，然后从excludeCache中删除
          // computed的getTagsName会重新计算，所以这里不用写死
          for (let i = 0; i < this.tags.length; i++) {
            if (this.tags[i].showName == val) {
              this.startMenu = this.tags[i]
            }
          }
          for (let j = 0; j < store.state.excludeCache.length; j++) {
            if (store.state.excludeCache[j] == this.startMenu.cssName) {
              store.state.excludeCache.splice(j, 1)
            }
          }
        }
        let index = this.tags.findIndex(function (value) {
          return value.showName == val;
        })
        this.$router.push(this.tags[index]?.linkUrl)


      },
      // immediate:true
    },

  },
  data () {
    return {
      index: 0,
      zvisible: false, // 右键菜单是否显示
      left: 0, // 右键菜单的位置
      top: 0, // 右键菜单的位置
      currentTab: "", // 当前选中的tab
      editableTabsValue: '',
      logo: logoImg,
      name: '',
      tags: store.getters['getMoveMenu'],
      firstPath: "",
      menuList: [],
      isCollapse: true,
      asideWidth: '210px',
      startMenu: '',
      n: 0,
    }
  },
  mounted () {
    this.plan()
    this.autoChangeWidth()
    window.onresize = () => {
      this.autoChangeWidth()
    }
  },
  methods: {
    change2 (event) {
      // 阻止事件冒泡
      // 阻止事件
      this.zvisible = false
    },
    // 关闭所有标签
    removeAll (event) {
      event.stopPropagation()
      this.tags = [];
      store.commit('clearMenu')
      this.zvisible = false
      // this.$router.push('/sys/homeone')
    },
    // 关闭左边标签
    closeLeft () {
      let index = 0;
      this.tags.forEach((el, i) => {
        if (this.currentTab == el.showName) {
          index = i;
        }
      });
      let arr = this.tags.slice(index, this.tags.length);
      this.tags = [];
      arr.forEach((el) => {
        if (el.showName != "index") {
          this.tags.push(el);
        }
      });
      store.commit('allMenu', this.tags)
      // 数组第一个元素
      this.activeName = this.tags[0].showName;
      this.zvisible = false
    },
    // 关闭右边标签
    closeRight () {
      let index = 0;
      this.tags.forEach((el, i) => {
        if (this.currentTab == el.showName) {
          index = i;
        }
      });
      let arr = this.tags.slice(0, index + 1);
      this.tags = arr;
      store.commit('allMenu', this.tags)
      // 数组最后一个元素
      this.activeName = this.tags[this.tags.length - 1].showName;
      this.zvisible = false
    },
    // 关闭其他标签
    closeOther () {
      let obj = {}; // 当前标签
      this.tags.forEach((el) => {
        if (this.currentTab == el.showName) {
          obj = el;
        }
      });
      this.tags = [obj];
      store.commit('allMenu', this.tags)
      this.activeName = obj.showName;
      this.zvisible = false
    },

    // tabs右键菜单
    openRightMenu (e) {
      this.zvisible = false;
      if (e.srcElement.id) {
        // 右键点击的是tab
        this.currentTab = e.srcElement.innerText;
        this.left = e.clientX;
        this.top = e.clientY;
        this.zvisible = true;
      }
    },
    autoChangeWidth () {
      // this.$nextTick(()=>{
      document.getElementsByClassName('el-tabs')[0].style.width = (document.getElementById('headerScoll').offsetWidth - document.getElementsByClassName('rightImage')[0].offsetWidth - 15) + 'px'
      // })
    },
    // 预加载
    plan () {

      this.editableTabsValue = this.tags[0]?.showName
    },
    removeTab (targetName) {
      // console.log(targetName,111)
      if (this.tags.length == 1) {
        // this.$router.push('/sys/homeone')
      }
      let tabs = this.tags;
      let activeName = this.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.showName === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.showName;
            }
          }
        });
      }
      let index = this.tags.findIndex(function (value) {
        return value.showName == targetName;
      })
      store.commit('deleteMenu', this.tags[index])
      this.editableTabsValue = activeName;
      this.tags = tabs.filter(tab => tab.showName !== targetName);
    },
    toLeft () {
      if (this.n == 0) {
        return
      }
      this.$nextTick(() => {
        this.n += 100
        let size = this.n + 'px'
        this.$refs.toScoll.style.marginLeft = size
      })

    },
    toRight () {

      this.$nextTick(() => {
        //   let width=document.getElementById('toScoll').offsetWidth
        let eqwidth = (document.getElementById('headerScoll').offsetWidth) / 100
        if (this.tags.length < 12 || (-this.n / 100) - 5 == this.tags.length) {
          return
        }
        this.n -= 100
        let size = this.n + 'px'
        this.$refs.toScoll.style.marginLeft = size
      })
    },
    toHome () {
      this.zvisible = false
      // this.$router.push('/sys/homeone')
    },
    changePwd () {
      this.$router.push('/sys/changepwd')
    },
    out () {
      this.$router.push('/login')
      localStorage.removeItem('Token')
      localStorage.removeItem('Name')
      localStorage.removeItem('corrent')
      localStorage.removeItem('allmenus')
      // localStorage.clear()
      // localStorage.clear()
    },
    open () {
      this.zvisible = false
      let that = this
      // if(item.linkUrl==this.$route.path) return
      let index = this.tags.findIndex(function (value) {
        return value.showName == that.editableTabsValue;
      })
      this.$router.push(this.tags[index].linkUrl)
      this.$refs.menu.activeIndex = this.tags[index].linkUrl
      this.firstPath = this.tags[index].linkUrl
    },
    change () {
      this.tags = store.state.movemenu
    },
    unload () {
      // window.sessionStorage.removeItem('Token')
      this.$router.push('/sys/homeone')
    },
    toCollapse () {
      if (this.isCollapse == true) {
        this.asideWidth = '70px'
      } else {
        this.asideWidth = '200px'
      }
      this.isCollapse = !this.isCollapse
    },
    findPath (arr) {
      for (let i = 0; i < arr?.length; i++) {
        if (this.$route.path == arr[i].path) {

          this.firstPath = arr[i].path
          //store.commit('addMenu',arr[i])
          return
        } else if (arr[i].children) {
          this.findPath(arr[i].children)
        }
      }
    },
    find2Path (arr, that) {
      let obarr = []
      for (let i = 0; i < arr?.length; i++) {
        if (that.$route.path == arr[i].linkUrl) {
          obarr.push(arr[i])
          store.commit('addMenu', arr[i])
          return
        } else if (arr[i].children) {
          find2Path(arr[i].children, that)
        }
      }
    }
  },
  async created () {

    // debugger
    let that = this
    this.name = localStorage.getItem('Name')
    //左侧菜单数据
    // let res =JSON.parse(localStorage.getItem('allmenus'))
    let res = [
      {
        linkUrl: '/sys/admin',
        id: '1',
        linkType: '_self',
        icon: 'el-icon-user',
        showName: '管理员管理',
        cssName:'user'
      }, {
        linkUrl: '/sys/appInfo',
        id: '2',
        linkType: '_self',
        icon: 'el-icon-open',
        showName: '应用管理',
        cssName:'app'
      }, {
        linkUrl: '/sys/notice',
        id: '4',
        linkType: '_self',
        icon: 'el-icon-bell',
        showName: '公告管理',
        cssName:'notice'
      }, {
        linkUrl: '/sys/chatMessage',
        id: '5',
        linkType: '_self',
        icon: 'el-icon-message',
        showName: '会话管理',
        cssName:'chatMessage'
      }, {
        linkUrl: '/sys/aiModelConfig',
        id: '6',
        linkType: '_self',
        icon: 'el-icon-copy-document',
        showName: '大模型管理',
        cssName:'aiModelConfig'
      }]
    this.menuList = res
    this.findPath(this.menuList)
    //顶部菜单数据
    this.find2Path(res, this)
    this.firstPath = this.$route.path
    //  当页面刷新时，就将当前路由的信息加入到vuex中
    // function find2Path (arr, that) {
    //   let obarr = []
    //   for (let i = 0; i < arr?.length; i++) {
    //     if (that.$route.path == arr[i].linkUrl) {
    //       obarr.push(arr[i])
    //       store.commit('addMenu', arr[i])
    //       return
    //     } else if (arr[i].children) {
    //       find2Path(arr[i].children, that)
    //     }
    //   }
    // }
  },
}
</script>

<style scoped>
:deep(.headerScoll) {
  display: flex;
  justify-content: space-between;
}
:deep(.el-tabs__nav-prev) {
  right: 20px !important;
  left: auto;
}
:deep(.el-tabs__nav-wrap.is-scrollable) {
  padding: 0 52px 0 0;
}
:deep(.el-tabs__nav-next),
:deep(.el-tabs__nav-prev) {
  line-height: 39px;
}
.tab {
  width: 100px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}
:deep(.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active:hover) {
  color: #fff;
}
:deep(.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active) {
  color: #fff;
  background-color: #409eff;
  border-right-color: #dcdfe6;
  border-left-color: #dcdfe6;
}
:deep(.el-tabs--border-card) {
  border: none;
  border-right: 1px solid #ccccccc7;
}
/* ::-webkit-scrollbar {
  display: none;
  width: 4px; 
  height: 10px;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
  background: #419efe47;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
  border-radius: 10px;
  background: #ededed;
} */
.arrow {
  position: fixed;
  right: 80px;
  top: 3px;
  background-color: white;
}
.el-dropdown {
  cursor: pointer;
}
.header {
  display: flex !important;
}
.changeCss {
  transition: all 0.5s;
  width: calc(100% - 87px);
  white-space: nowrap;
  gap: 5px;
}
.headertext {
  font-size: 17px;
  line-height: 49px;
}
.headericon {
  line-height: 20px;
  vertical-align: middle;
}
.el-container {
  height: 100%;
  min-height: 100%;
}
.is-vertical {
  height: 100%;
}

>>> .el-header {
  position: relative;
  /* display: flex; */
  /* flex-direction: row;
  justify-content: space-between; */
  /* overflow: hidden; */
  /* min-height: 64px; */
  /* height: auto !important; */
  padding: 0 0 0 0;
  background-color: #f5f7fa;
  box-shadow: 0px 6px 10px #ccc;
  color: #333744;
  /* text-align: left; */
  line-height: 30px;

  height: 40px !important;
  /* font-size: 25px; */
  /* font-weight: bold; */
  /* border-bottom: 1px solid #d8dce5; */
  /* box-shadow: 0 1px 3px 0 rgba(0,0,0,.12), 0 0 3px 0 rgba(0,0,0,.04); */
}

.el-button {
  height: 32px;
  margin: auto 0;
}

.el-aside {
  background-color: #333744;
  color: #fffff3;
  overflow-y: auto;
  overflow-x: hidden;
}

.el-main {
  color: #333;
}
.havePad {
  padding: 0 !important;
}
.collapseBtn {
  display: block;
  margin: 10px 0;
  cursor: pointer;
}

.el-menu {
  width: 100%;
  background-color: rgb(48, 65, 86);
}
.el-tag {
  cursor: pointer;
}
.headerImage {
  display: inline-block;
  float: right;
  width: 40px;
  height: 40px;
  margin-top: 12px;
  background-color: pink;
  border-radius: 50%;
}
.rightImage {
  position: absolute;
  right: 0px;
  top: 3px;
  /* padding-right:10px; */
}
.sidebar-logo {
  width: 45px;
  height: 45px;
}
:deep(.el-tabs--border-card > .el-tabs__content) {
  padding: 0;
}

.zdiv {
  margin: 0;
  border: 1px solid rgb(187, 186, 186);
  background: rgb(255, 255, 255);
  z-index: 1000;
  position: absolute;
  list-style-type: none;
  padding: 5px;
  border-radius: 7px;
  font-size: 12px;
}
.zdiv li {
  margin: 0;
  padding: 5px;
  padding-top: 7px;
  padding-bottom: 7px;
}
.zdiv li:hover {
  background: #e1e1e1;
  cursor: pointer;
}
.el-tabs--border-card {
  box-shadow: none;
}
</style>
